
export default {
  inputCancel: 'Cancelar',
  inputAccept: 'Aceptar'
}
